import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ControlLabel, FormGroup } from 'react-bootstrap';
import MapWrapper from '../../common/graphs/crossfilterGraphs/util/mapWrapper';

class MapInfo extends Component {
  constructor(props, context) {
    super(props, context);
    var value = props.value;
    try {
      value = JSON.parse(value);
    } catch (e) {
      value=null;
    }

    this.state = { value: value };
  }

  componentWillReceiveProps(nextProps) {
    var value;
    if(nextProps.value!=null) {
      try {
        value = JSON.parse(nextProps.value);
      } catch (e) {
        value=null;
      }
      this.state.value = value;
    }
  }

  render() {
    var input = null;
    var readOnly = null;
    if(this.props.readOnly && this.state.value!=null) {
      input = null;
      readOnly = (
        <div className="mapInfo">
          <MapWrapper
            routePath={[]}
            eventPolylines={[]}
            eventsIcons={[{point:[this.state.value[0], this.state.value[1]],color:"#EF811D"}]}
          />
        </div>
      );
    }

    return (
      <div id={this.props.id} className={this.props.className}>
        <FormGroup>
          <ControlLabel>{this.props.label}</ControlLabel>
          {readOnly}       
          {input}
        </FormGroup>
      </div>
    );
  }
}

MapInfo.propTypes = {};

export default MapInfo;



// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/form_components/mapInfo.jsx